export const TIMEOUT_CLOSE_BRAND_DEFAULT = 200
export const TIMEOUT_HOVER_OUTSIDE = 210
export const TIMEOUT_BACK_ACTION = 100
export const TIMEOUT_LABELS_READY = 200
